"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../constants");
var _button = _interopRequireDefault(require("../button"));
var _use_modal = _interopRequireDefault(require("./use_modal"));
var _typography = _interopRequireDefault(require("../typography"));
var _form_submit_buttons = _interopRequireDefault(require("../form_submit_buttons"));
var _modal = require("./modal");
var _excluded = ["children", "warningText", "onConfirm", "modalContent", "submitText", "dangerText", "disableSubmitButton", "title"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var WarningModal = function WarningModal(props) {
  var children = props.children,
    warningText = props.warningText,
    onConfirm = props.onConfirm,
    modalContent = props.modalContent,
    submitText = props.submitText,
    dangerText = props.dangerText,
    disableSubmitButton = props.disableSubmitButton,
    title = props.title,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useModal = (0, _use_modal["default"])(false),
    _useModal2 = (0, _slicedToArray2["default"])(_useModal, 3),
    open = _useModal2[0],
    openModal = _useModal2[1],
    closeModal = _useModal2[2];
  function confirm() {
    onConfirm();
    closeModal();
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(children, {
    onClick: openModal
  }), /*#__PURE__*/React.createElement(_modal.Modal, null, /*#__PURE__*/React.createElement(_modal.Container, (0, _extends2["default"])({}, restProps, {
    open: open,
    closeModal: closeModal,
    draggable: false,
    "data-provides": "warning-modal"
  }), /*#__PURE__*/React.createElement(RedHeader, {
    title: title,
    closeModal: closeModal,
    displayXIcon: false,
    draggable: false
  }), /*#__PURE__*/React.createElement(_modal.Content, null, warningText ? /*#__PURE__*/React.createElement(_typography["default"], {
    type: "p"
  }, warningText) : modalContent), /*#__PURE__*/React.createElement(_modal.Footer, null, /*#__PURE__*/React.createElement(_form_submit_buttons["default"], {
    onSubmit: closeModal,
    onCancel: confirm,
    submitText: submitText || _form_submit_buttons["default"].defaultProps.submitText,
    compact: true,
    cancelComponent: /*#__PURE__*/React.createElement(_button["default"], {
      danger: true,
      disabled: disableSubmitButton
    }, dangerText)
  })))));
};
var _default = WarningModal;
exports["default"] = _default;
WarningModal.defaultProps = {
  open: false,
  fullScreen: false,
  fullWidth: true,
  maxWidth: 'sm',
  disableSubmitButton: false
};
var RedHeader = (0, _styledComponents["default"])(_modal.Header).withConfig({
  displayName: "warning_modal__RedHeader"
})(["background-color:", ";#modal_title{color:", ";}"], _constants.colors.darkRed, _constants.colors.white);